const state = {
    showAlert : false,
    isSuccess : false,
    alertMessage : []
}

const getters = {
    getShowAlert : state => {
        return state.showAlert
    },
    getIsSuccess : state => {
        return state.isSuccess
    },
    getAlertMessage : state => {
        return state.alertMessage
    },
    getAlertStatus : state => {
        return {
            showAlert : state.showAlert,
            isSuccess : state.isSuccess,
            alertMessage : state.alertMessage
        }
    }
}

const mutations = {
    showAlertStatus (state, showAlert){
        if(typeof showAlert == 'boolean'){
            state.showAlert = showAlert;
        } else {
            state.showAlert = false;
        }
    },
    isSuccessStatus (state, isSuccess){
        if(typeof isSuccess == 'boolean'){
            state.isSuccess = isSuccess;
        } else {
            state.isSuccess = false;
        }
    },
    alertMessageStatus (state, alertMessage){
        state.alertMessage.length = 0;
        if(alertMessage != null && Array.isArray(alertMessage) && alertMessage.length > 0){
            state.alertMessage = state.alertMessage.concat(alertMessage);
        }
    },
    triggerAlertStatus (state, alert){//isSuccess[boolean], alertMessage[array of string]
        state.alertMessage.length = 0;

        if(alert != null){
            state.isSuccess = alert[0];
            state.alertMessage = state.alertMessage.concat(alert[1]);
    
            state.showAlert = true;
            // setTimeout(()=>{
            //     state.showAlert = false;
            // }, 5000);
        } else {
            state.showAlert = false;
            state.isSuccess = false;
        }
    }
}

const actions = {
    setShowAlert ({ commit }, showAlert){
        commit('showAlertStatus', showAlert);
    },
    setIsSuccess ({ commit }, isSuccess){
        commit('isSuccessStatus', isSuccess);
    },
    setAlertMessage ({ commit }, alertMessage){
        commit('alertMessageStatus', alertMessage);
    },
    triggerAlert({ commit }, alert){
        commit('triggerAlertStatus', alert);
    }
}

export default{
    state,
    getters,
    mutations,
    actions
}